import 'core-js/stable';
import 'regenerator-runtime/runtime';

window.Content = require('./app/views/content.js');
window.Alert = require('./app/views/components/alert.js');
window.Modal = require('./app/views/components/modal.js');
window.PasswordGenerator = require('./app/util/passwordGenerator.js');
window.PropertyTypeMask = require('./app/util/masks.js');
window.PropertiesFormHelper = require('./app/util/propertiesFormHelper.js');
window.DataTables = require('./app/views/components/dataTables.js');
window.DataTableIniter = require('./app/views/components/dataTablesIniter.js');
window.PuppetProfilesOrder = require('./app/views/components/puppetProfilesOrder.js');
window.Analytics = require('./app/util/analytics.js');
window.Errors = require('./app/util/errors.js');
window.StoreHierarchyWidget = require('./app/views/components/inline/storeHierarchyWidget.jsx');
window.PackageLogPage = require('./app/views/components/inline/packageLogPage.jsx');
window.Reports = require('./app/views/components/inline/reports.jsx');
window.BulkActions = require('./app/views/components/bulkActions.js');
window.PersistentActions = require('./app/views/components/persistentActions.js');
window.Messenger = require('./app/views/components/messenger.js');
window.PaymentDeviceSerialRetrieval = require('./app/views/content/payment_devices/serial_retrieval.js');
window.ServerTypeWarning = require('./app/views/components/serverTypeWarning.js');
window.Timezone = require('./app/views/components/inline/timezone.jsx');
window.DateTime = require('./app/views/components/inline/dateTime.jsx');
window.Field = require('./app/views/components/inline/field.jsx');
window.DatePicker = require('./app/views/components/inline/datePicker.jsx');
window.RVCTextbox = require('./app/views/components/inline/rvcTextbox.jsx');
window.ServiceCheckTextbox = require('./app/views/components/inline/serviceCheckTextbox.jsx');
window.DockerImagesTextbox = require('./app/views/components/inline/dockerImagesTextbox.jsx');
window.HashBuilder = require('./app/views/components/inline/hashBuilder.jsx');
window.HashPropertyActions = require('./app/views/components/inline/hashPropertyActions.jsx');
window.HashForm = require('./app/views/components/inline/hashForm.jsx');
window.Hierarchy = require('./app/views/components/inline/hierarchy.jsx');
window.NodeRQLSearch = require('./app/views/components/inline/NodeRqlSearch.jsx');
window.RQLSearchHtmx = require('./app/views/components/inline/rqlSearchHtmx.jsx');
window.EdgeMonitor = require('./app/views/components/inline/edgeMonitor.jsx');
window.FiltersIndexPage = require('./app/views/components/inline/filtersIndexPage.jsx');
window.Impact = require('./app/views/components/inline/impact.jsx');
window.Initializer = require('./app/components/Initializer.js');
window.NodesFailOver = require('./app/views/content/nodes/fail_over.js');
window.ClusterVIPS = require('./app/views/content/cluster_settings/vips.js');
window.UserRoleRetrieval = require('./app/views/content/users/user_role_retrieval.js');
window.PrimaryCustomerRetrieval = require('./app/views/content/users/primary_customer_retrieval.js');
window.ConfirmationStringModal = require('./app/views/components/confirmationStringModal.js');
window.Container = require('./app/views/components/inline/container.jsx');
window.FirewallPolicyPreview = require('./app/views/components/inline/firewallPolicyPreview.jsx');
window.EdgeTokenFormSection = require('./app/views/components/inline/edgeTokenForm.jsx');
window.RpmLogPreview = require('./app/views/components/inline/rpmLogPreview.jsx');
window.QRCodeBatchSearch = require('./app/views/components/inline/qrCodeBatchSearch.jsx');
